;(function (global, factory) {
    typeof define === 'function' && define.amd ? define('MM/Models/ClientPortal/AccountSettings/CountrySelectionModel',['knockout'], factory) :
    typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require('knockout')) :
    console && console.log('CountrySelectionModel works only in AMD')
  }(this/* window */, function (ko) { 
    function CountrySelectionModel(scope, initialUserData) {
      if(!scope) throw Error('Cannot create CountrySelectionModel without scope element.');
  
      this._loadDependencies();
  
      Object.defineProperty(this, 'scope', { writable: !1, configurable: !0, enumerable: !0, value: scope });
      Object.defineProperty(this, 'initialUserData', {writable: !1, configurable:!0, enumerable: !0, value: initialUserData});
      Object.defineProperty(this, 'selectedCountryCode', {writable: !1, configurable: !0, enumerable: !0, value: ko.observable('')});
      Object.defineProperty(this, 'addressLine1', {writable: !1, configurable: !0, enumerable: !0, value: ko.observable('')});
      Object.defineProperty(this, 'addressLine2', {writable: !1, configurable: !0, enumerable: !0, value: ko.observable('')});
      Object.defineProperty(this, 'city', {writable: !1, configurable: !0, enumerable: !0, value: ko.observable('')});
      Object.defineProperty(this, 'stateCode', {writable: !1, configurable: !0, enumerable: !0, value: ko.observable('')});
      Object.defineProperty(this, 'stateText', {writable: !1, configurable: !0, enumerable: !0, value: ko.observable('')});
      Object.defineProperty(this, 'zipCode', {writable: !1, configurable: !0, enumerable: !0, value: ko.observable('')});
      Object.defineProperty(this, 'isUSCountrySelected', {writable: !1, configurable: !0, enumerable: !0, value: ko.pureComputed(this._isUSCountrySelected, this)});
      Object.defineProperty(this, 'isCanadaCountrySelected', {writable: !1, configurable: !0, enumerable: !0, value: ko.pureComputed(this._isCanadaCountrySelected, this)});
      Object.defineProperty(this, 'isInternationalCountrySelected', {writable: !1, configurable: !0, enumerable: !0, value: ko.pureComputed(this._isInternationalCountrySelected, this)});

      this._setupEventHandlers();
      this._wrapFunctions();
      this._loadInitialUserData();
      this._setupInstance();
    }

    CountrySelectionModel.prototype.clickStateCode = function clickStateCode(context, event) {
      var optionEl = event.currentTarget;
      this.stateCode(optionEl.getAttribute('data-value'));
      this.stateText(optionEl.innerText);
    }

    CountrySelectionModel.prototype.selectedCountryText = function selectedCountryText(defaultText) {
      if(!!this.selectedCountryCode()) {
        var stateEl = this.scope.querySelector('.user_countrycode .list-option[data-value=\'' + this.selectedCountryCode() + '\']');
        if(!!stateEl) {
          return stateEl.innerText;
        }
      }

      return defaultText;
    }

    CountrySelectionModel.prototype.selectedStateText = function selectedStateText(defaultText) {
      // we need this logic to build knockout binding properly
      if(!this.stateText()){
        if(!!this.stateCode()) {
          var stateEl = this.scope.querySelector('.user_statecode .list-option[data-value=\'' + this.stateCode() + '\']');
          if(!!stateEl) {
            this.stateText(stateEl.innerText);
          }
        }
      }

      if(!!this.stateText()) {
        return this.stateText();
      }

      return defaultText;
    }

    CountrySelectionModel.prototype.onSelectedCountryCodeChange = function onSelectedCountryCodeChange() {
      console.log('onSelectedCountryCodeChange')
      // cleanup address form from another country
      this._cleanupAddressFields();
    }

    
    CountrySelectionModel.prototype._cleanupAddressFields = function _cleanupAddressFields() {
      this.addressLine1(null);
      this.addressLine2(null);
      this.city(null);
      this.stateCode(null);
      this.stateText(null);
      this.zipCode(null);

    }

    CountrySelectionModel.prototype._isUSCountrySelected = function _isUSCountrySelected() {
      return this.selectedCountryCode() == 'US'
    }

    CountrySelectionModel.prototype._isCanadaCountrySelected = function _isCanadaCountrySelected() {
      return this.selectedCountryCode() == 'CA'
    }

    CountrySelectionModel.prototype._isInternationalCountrySelected = function _isInternationalCountrySelected() {
      return !this._isUSCountrySelected() && !this._isCanadaCountrySelected();
    }
    
    CountrySelectionModel.prototype._loadDependencies = function _loadDependencies() {
  
    }
  
    CountrySelectionModel.prototype._setupEventHandlers = function _setupEventHandlers() {
      this.selectedCountryCode.subscribe(this.onSelectedCountryCodeChange.bind(this));
    }
  
    CountrySelectionModel.prototype._triggerOnChanged = function _triggerOnChanged() {
      this.onChangedHandlers.forEach(function(fn) { fn(this.value); }, this);
    }

    CountrySelectionModel.prototype._wrapFunctions = function _wrapFunctions() {
    }

    CountrySelectionModel.prototype._loadInitialUserData = function _loadInitialUserData() {
      if(!this.initialUserData) return;

      this.selectedCountryCode(this.initialUserData.CountryCode);
      this.addressLine1(this.initialUserData.Address);
      this.addressLine2(this.initialUserData.Address2);
      this.city(this.initialUserData.City);
      this.stateCode(this.initialUserData.StateCode);
      this.zipCode(this.initialUserData.ZipCode);
    }
  
    CountrySelectionModel.prototype._setupInstance = function _setupInstance() {
  
      // setup view model
      ko.applyBindings(this, this.scope);
    }
  
    return CountrySelectionModel;
  }));
